import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { CopyPlus, Loader2 } from "lucide-react";
import { toast } from "sonner";

export const DuplicateRfqButton = ({ rfq }) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/rfqs/${rfq.id}/duplicate`);
      toast.success(`Duplicated as ${data.code}`);
      setOpen(false);
      navigate(`/rfqs/${data.id}`);
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };
  return (
    <>
      <Button variant="outline" onClick={() => setOpen(true)} data-testid="rfq-duplicate-btn"><CopyPlus className="mr-2 h-4 w-4" />Duplicate</Button>
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent data-testid="rfq-duplicate-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>Duplicate {rfq.code}?</AlertDialogTitle>
            <AlertDialogDescription>
              Creates a new request with its own SOM-REQ number, the same client, details, line items and assigned suppliers.
              Supplier prices, costing, quotes and history are not copied.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="rfq-duplicate-cancel">Cancel</AlertDialogCancel>
            <AlertDialogAction onClick={(e) => { e.preventDefault(); go(); }} disabled={busy} className="bg-[#1B4383] hover:bg-[#16386e]" data-testid="rfq-duplicate-confirm">
              {busy ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : null}Duplicate
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};

export default DuplicateRfqButton;
